import { Link, useHistory } from "react-router-dom";
import "./footer.css";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import axios from "axios";
import { getFilteredProducts } from "../../../redux/actions";

const Footer = () => {

    const categories = useSelector((state) => state.categoryDetail.categories);
    const [pages, setPages] = useState()
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        fetchPages();
    }, [])

    const fetchPages = async () => {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/v1/cms/get-pages-by-footer`);
        setPages(response.data);
    }


    return (
        <footer id="DefaultFooter" className="bg-black">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-6">
                        <div className="footer-content">
                            <h1>CATEGORIES</h1>
                            <ul className="list-unstyled">
                                {categories.map((cat, index) => {
                                    if (cat.feature) {
                                        return (<li><button className={`btn-footer ${window.location.search === `?categoryId=${cat._id}` ? "active" : ""}`} onClick={() => {
                                            const queryParams = new URLSearchParams({ categoryId: cat._id });
                                            if (window.location.pathname !== "/search-result")
                                                history.push(
                                                    { pathname: '/search-result', search: queryParams.toString() });
                                            else {
                                                history.replace(
                                                    {
                                                        pathname: '/search-result', search: queryParams.toString(),
                                                        state: { viaOther: true, categoryId: cat._id }
                                                    });
                                            }
                                        }}>{cat.name}</button></li>);
                                    }
                                })}
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-6">
                        <div className="footer-content">
                            <h1>Menu</h1>
                            <ul className="list-unstyled">
                                <li><Link to="/about-us" className={window.location.pathname === "/about-us" ? "active" : ""}>About</Link></li>
                                <li><Link to="/help" className={window.location.pathname === "/help" ? "active" : ""}> Help/FAQ</Link></li>
                                <li><Link to="/contact-us" className={window.location.pathname === "/contact-us" ? "active" : ""}>Contact</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-6">
                        <div className="footer-content">
                            <h1>Livestock</h1>
                            <ul className="list-unstyled">
                                {/* <li><Link to={window.location.pathname}>Privacy policy</Link></li>
                                <li><Link to={window.location.pathname}>Conditions of use</Link></li>
                                <li><Link to={window.location.pathname}>Conditions of Sale</Link></li>
                                <li><Link to="/help">FAQs</Link></li> */}
                                {pages && pages.map((page, key) => <li key={key}><Link to={`/cms/${page.slug}`} className={window.location.pathname === `/cms/${page.slug}` ? "active" : ""}>{page.title}</Link></li>)}
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-6">
                        <div className="footer-content">
                            <h1>Social Links</h1>
                            <div className="social-links">
                                <Link target="_blank" to={window.location.pathname} className="lnk-fb">
                                    <i className="fa fa-twitter"></i>
                                </Link>
                                <Link target="_blank" to={window.location.pathname} className="lnk-yt">
                                    <i className="fa fa-facebook"></i>
                                </Link>
                                <Link target="_blank" to={window.location.pathname} className="lnk-wapp">
                                    <i className="fa fa-instagram"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="copyright">
                    <p>LiveStock Copyright © {new Date().getFullYear()}. All rights reserved</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;